import {all, fork, put, takeEvery,takeLatest, call, delay} from "redux-saga/effects"

import {
  OCCUPATION_PREVIEW,
  OCCUPATION_NEW,
  OCCUPATION_UPDATE,
  OCCUPATION_REMOVE,
  OCCUPATION_SEARCH
} from "constants/ActionTypes"

import {occupationDataSourceUpdate,occupationProcessSuccess,occupationProcessReset} from "appRedux/actions/setup/miscellaneous/Occupation"
import {userSignOut} from "appRedux/actions/Auth"

import { APIGetRequest,APIPostRequest } from "util/connection"
import { API_URL_V1,API_PMS_HEADERS } from "constants/ApiSetting"
import { isUndefined,filter,orderBy } from "lodash"
import { IndexedDBAdd,IndexDBGetDataAll } from "util/indexedDBLibrary"
import { getItems } from "util/localStorage"

function* occupationPreviewProcess(){

    const  { access_token }  = yield call(getItems, ['access_token'])
    const AccessToken = access_token
    const url = `${API_URL_V1}pms/masterfile/occupation/`
    API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
    
    try {
      const response = yield APIGetRequest(url,API_PMS_HEADERS)

      if(response.status === 200)
      {
            const occupationDataSource = orderBy(response.data,[o => o.name.toLowerCase()],['asc']).map((obj,key) =>{
              const container = {}
                    container.key = key+1
                    container.occupation_id = obj.id
                    container.occupation_name = obj.name
                    container.enabled = obj.enabled
                return container
            })
            
            /* if no error put everything to reducer */
            yield put(occupationDataSourceUpdate(occupationDataSource))
            yield delay(100)
            yield IndexedDBAdd("ListBoxDB","objStoreOccupationList",occupationDataSource)

      }else{
            /* Show error message and signout */
            const {message,data} = response.data
            const processStatus = { status: false, action: "preview", message}
            yield put(occupationProcessSuccess(processStatus))
            yield delay(100)
            if(response.status === 403){
              /* if data is not null force signout */
              if(data)
                yield put(userSignOut())
            }
            
      }
      
    } catch (error) {
        const processStatus = { status: false, action: "preview", message:error}
        yield put(occupationProcessSuccess(processStatus))
        yield delay(100)
    }
    
}

function* occupationSearchProcess({payload}){
  const storeValue = yield IndexDBGetDataAll('ListBoxDB', 'objStoreOccupationList')
  const ReformalData = [...storeValue[0]]
  const keyword = payload.toLowerCase()

  if(!isUndefined(keyword)){
      /* Search by name */
      const filtered = filter(ReformalData, function(o) {
        return (o.title_name.toLowerCase().indexOf(keyword) > -1)
      })

      const mergeData = [...new Set([...filtered])]

      yield put(occupationDataSourceUpdate(mergeData))
      yield delay(100)
  }else 
      yield put(occupationDataSourceUpdate(ReformalData))
      yield delay(100)
}

function* occupationCreateProcess({payload}){
  
  const { occupation_name, enabled } = payload
  const occupationInfo = {}
        occupationInfo.name = occupation_name
        occupationInfo.enabled = enabled
      
      try {
            const  { access_token }  = yield call(getItems, ['access_token'])
            const AccessToken = access_token
            const url = `${API_URL_V1}pms/masterfile/occupation/create/`
            API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
            const API_DATABODY  = occupationInfo
            const response = yield APIPostRequest(url,API_DATABODY,API_PMS_HEADERS)

            if(response.status === 200){
                const processStatus = { status: true, action: "create", message:"Create success."}
                yield put(occupationProcessSuccess(processStatus))
                yield delay(100)
            }else{
              const {message,data} = response.data
              const processStatus = { status: false, action: "create", message}
              yield put(occupationProcessSuccess(processStatus))
              yield delay(100)
              yield put(occupationProcessReset())
              if(response.status === 403){
                /* if data is not null force signout */
                if(data)
                  yield put(userSignOut())
              } 
            }  

      } catch (error) {
            const processStatus = { status: false, action: "create", message:error}
            yield put(occupationProcessSuccess(processStatus))
            yield delay(100)
            yield put(occupationProcessReset())
      }
}

function* occupationUpdateProcess({payload}){

  const { occupation_id, occupation_name, enabled } = payload
  const occupationInfo = {}
        occupationInfo.id = occupation_id
        occupationInfo.name = occupation_name
        occupationInfo.enabled = enabled
  
  
  try {
        const  { access_token }  = yield call(getItems, ['access_token'])
        const AccessToken = access_token
        const url = `${API_URL_V1}pms/masterfile/occupation/update/`
        API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
        const API_DATABODY  = occupationInfo
        const response = yield APIPostRequest(url,API_DATABODY,API_PMS_HEADERS)

        if(response.status === 200){
            const processStatus = { status: true, action: "update", message:"Update success."}
            yield put(occupationProcessSuccess(processStatus))
            yield delay(100)
            yield put(occupationProcessReset())
        }else { 
          const {message,data} = response.data
          const processStatus = { status: false, action: "update", message}
          yield put(occupationProcessSuccess(processStatus))
          yield delay(100)
          yield put(occupationProcessReset())
          if(response.status === 403){
            /* if data is not null force signout */
            if(data)
              yield put(userSignOut())
          }
        } 

  } catch (error) {
        const processStatus = { status: false, action: "update", message:error}
        yield put(occupationProcessSuccess(processStatus))
        yield delay(100)
        yield put(occupationProcessReset())
  }
}

function* occupationRemoveProcess({payload}){
    const occupationRemoveID = payload
    
    try{
        const  { access_token }  = yield call(getItems, ['access_token'])
        const AccessToken = access_token
        const url = `${API_URL_V1}pms/masterfile/occupation/delete/`
        API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
        const API_DATABODY = {id : occupationRemoveID}
        const response = yield APIPostRequest(url,API_DATABODY,API_PMS_HEADERS)
        if(response.status === 200){
          const processStatus = { status: true, action: "delete", message:"Delete success."}
          yield put(occupationProcessSuccess(processStatus))
          yield delay(100)
        }else{
          const {message,data} = response.data
          const processStatus = { status: false, action: "delete", message}
          yield put(occupationProcessSuccess(processStatus))
          yield delay(100)
          yield put(occupationProcessReset())
          if(response.status === 403){
            /* if data is not null force signout */
            if(data)
              yield put(userSignOut())
          }
        }  
    }
    catch(error){
      const processStatus = { status: false, action: "delete", message:error}
      yield put(occupationProcessSuccess(processStatus))
      yield delay(100)
      yield put(occupationProcessReset())
    }
}

/* Watcher Saga */
export function* occupationPreview() {
  yield takeLatest(OCCUPATION_PREVIEW, occupationPreviewProcess)
}
export function* occupationSearch(){
  yield takeLatest(OCCUPATION_SEARCH, occupationSearchProcess)
}
export function* occupationCreate(){
  yield takeEvery(OCCUPATION_NEW,occupationCreateProcess)
}
export function* occupationUpdate(){
  yield takeEvery(OCCUPATION_UPDATE, occupationUpdateProcess)
}
export function* occupationRemove(){
  yield takeEvery(OCCUPATION_REMOVE,occupationRemoveProcess)
}

export default function* rootSaga() {
  yield all([fork(occupationPreview),
             fork(occupationCreate),
             fork(occupationUpdate),
             fork(occupationRemove)])
}
